import type { AdminBillingUsageRow } from "@lumora/bridge";
import type { BillingUsageTotals } from "@lumora/core";
import { formatUsd } from "@lumora/core";
import { formatBytesGB } from "./siteTrafficMetrics.js";

/** UTC `YYYY-MM` for a date (default now). */
export function currentUtcPeriod(now: Date = new Date()): string {
  return `${now.getUTCFullYear()}-${String(now.getUTCMonth() + 1).padStart(2, "0")}`;
}

export function isValidPeriod(p: string): boolean {
  return /^\d{4}-(0[1-9]|1[0-2])$/.test(p);
}

const n = (v: number): string => v.toLocaleString("en-US");

/** Per-tenant ledger table with a totals row (#1243). Dumb view. */
export function BillingUsageTable({
  rows,
  totals,
}: {
  rows: AdminBillingUsageRow[];
  totals: BillingUsageTotals;
}) {
  if (rows.length === 0) {
    return <p className="muted">No usage recorded for this period.</p>;
  }
  return (
    <div className="ops-table-wrap">
      <table className="ops-table platform-billing-table" data-lumora-billing-table>
        <thead>
          <tr>
            <th>Site</th>
            <th>Status</th>
            <th>API requests</th>
            <th>R2 ops (est.)</th>
            <th>Storage</th>
            <th>API</th>
            <th>R2</th>
            <th>Storage $</th>
            <th>Billed</th>
          </tr>
        </thead>
        <tbody>
          {rows.map((r) => (
            <tr key={`${r.tenantId}-${r.period}`}>
              <td>{r.slug}</td>
              <td>
                <span
                  className="platform-billing-badge"
                  data-lumora-billing-status={r.status}
                >
                  {r.status}
                </span>
              </td>
              <td>{n(r.apiRequests)}</td>
              <td>{n(r.r2WriteOps + r.r2ReadOpsEst)}</td>
              <td>{formatBytesGB(r.storageBytes)}</td>
              <td>{formatUsd(r.apiCents)}</td>
              <td>{formatUsd(r.r2Cents)}</td>
              <td>{formatUsd(r.storageCents)}</td>
              <td>{formatUsd(r.billedCents)}</td>
            </tr>
          ))}
        </tbody>
        <tfoot>
          <tr data-lumora-billing-totals>
            <th colSpan={5}>Total</th>
            <th>{formatUsd(totals.apiCents)}</th>
            <th>{formatUsd(totals.r2Cents)}</th>
            <th>{formatUsd(totals.storageCents)}</th>
            <th>{formatUsd(totals.billedCents)}</th>
          </tr>
        </tfoot>
      </table>
    </div>
  );
}
